import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import ProviderDetails from './ProviderDetails';

const ProviderProfile = () => {
  const [provider, setProvider] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const user = useSelector((state) => state?.user?.user);
  const routerLocation = useLocation();
  const id = user?.providerId
  console.log(id, "id")// Get ID from URL if present

  useEffect(() => {
    console.log("Redux user object:", user);
    
    const fetchProviderData = async () => {
      // Determine which provider ID to use
      let providerId = null;
      
      if (id) {
        // If ID is in URL, use it (admin viewing a specific provider)
        providerId = id;
      } else if (user?.role === "provider" && user?.providerId) {
        // If no ID in URL but user is a provider, use their own ID
        providerId = user.providerId;
      } else if (user?.role === "provider" && user?.id) {
        // Fallback: sometimes the provider ID might be stored as user.id
        providerId = user.id;
      }

      if (providerId) {
        console.log("Fetching provider data with ID:", providerId);
        try {
          setIsLoading(true);
          const response = await axios.get(
            `${process.env.REACT_APP_BASE_URL}/specialist/provider/${id}`
          );
          console.log('Fetched provider from API:', response.data);
          
          if (response.data.success) {
            setProvider(response.data.data);
          } else {
            console.error('API returned success: false', response.data);
            toast.error('Failed to fetch provider data');
          }
        } catch (error) {
          console.error('Error fetching provider:', error);
          // More specific error handling
          if (error.response) {
            // Server responded with error status
            console.error('Server error:', error.response.status, error.response.data);
            toast.error(`Server error: ${error.response.data.message || 'Failed to fetch provider data'}`);
          } else if (error.request) {
            // Request was made but no response received
            console.error('Network error:', error.request);
            toast.error('Network error: Please check your connection');
          } else {
            // Something else happened
            console.error('Request setup error:', error.message);
            toast.error('Error setting up request');
          }
        } finally {
          setIsLoading(false);
        }
      } else {
        console.warn("No provider ID found. User:", user);
        console.warn("URL params:", { id });
        setIsLoading(false);
        toast.error('Provider ID not found. Please ensure you are logged in as a provider.');
      }
    };
  
    fetchProviderData();
  }, [user, id]); // Add id as dependency

  // Enhanced loading state
  if (isLoading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '400px',
        flexDirection: 'column',
        gap: '16px'
      }}>
        <div style={{
          width: '40px',
          height: '40px',
          border: '4px solid #f3f3f3',
          borderTop: '4px solid #20B2AA',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite'
        }}></div>
        <div style={{ fontSize: '16px', color: '#666' }}>
          Loading your profile...
        </div>
        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  // Enhanced error state
  if (!provider) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '400px',
        flexDirection: 'column',
        gap: '16px',
        padding: '20px',
        textAlign: 'center'
      }}>
        <div style={{
          fontSize: '48px',
          color: '#ddd',
          marginBottom: '16px'
        }}>
          😔
        </div>
        <div style={{ 
          fontSize: '18px', 
          color: '#333',
          marginBottom: '8px',
          fontWeight: '600'
        }}>
          No provider data available
        </div>
        <div style={{ 
          fontSize: '14px', 
          color: '#666',
          maxWidth: '400px',
          lineHeight: '1.5'
        }}>
          {user?.role !== 'provider' 
            ? 'You need to be logged in as a provider to view this page.'
            : 'Unable to load your profile information. Please try refreshing the page or contact support if the issue persists.'
          }
        </div>
        <button 
          onClick={() => window.location.reload()} 
          style={{
            marginTop: '16px',
            padding: '12px 24px',
            background: '#20B2AA',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: '500'
          }}
        >
          Try Again
        </button>
      </div>
    );
  }

  // Create location object to pass provider data to ProviderDetails
  const location = {
    ...routerLocation,
    state: {
      ...(routerLocation.state || {}),
      provider: provider,
    },
  };

  // Determine if this is the provider's own profile
  const isOwnProfile = !id || (user?.providerId === id) || (user?.id === id);

  console.log("Rendering ProviderDetails with provider:", provider);
  console.log("Is own profile:", isOwnProfile);

  return (
    <div>
      <ProviderDetails 
        location={location} 
        isOwnProfile={isOwnProfile}
      />
    </div>
  );
};

export default ProviderProfile;